import { createFileRoute } from "@tanstack/react-router";

import { LedgerTableContainer } from "@/features/ledger/ledger-table.container";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ledger",
)({
  component: Ledger,
  staticData: {
    breadcrumb: ["bank.link"],
  },
});

function Ledger() {
  return (
    <div className="flex-1 px-4 pb-4 h-full">
      <LedgerTableContainer />
    </div>
  );
}
